import { gql } from '@apollo/client';

export const LOGIN_MUTATION = gql`
  mutation Login($username: String!, $password: String!, $platform: String!, $instance: String!) {
    login(username: $username, password: $password, platform: $platform, instance: $instance) {
      success
      message
      errors
      data {
        tenantId
        userId
        userName
        name
        tenantType
        token
        permissions
      }
    }
  }
`;
